﻿import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TextMaskModule } from 'angular2-text-mask';
import { BreadcrumbModule } from '../../core/breadcrumb/breadcrumb.module';
import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { OfflineDebatesListComponent } from './offline-debates-list/offline-debates-list.component';
import { OfflineDebatesRoutingModule } from './offline-debates-routing.module';
import { OfflineDebatesService } from './offline-debates.service';
import { OfflineDebateDetailsComponent } from './offline-debates-detail/offline-debates-detail.component';
import { SharedDebatesModule } from '../shared/shared-debates.module';
import { OfflineDebateSessionsComponent } from './offline-debates-detail/offline-debate-sessions/offline-debate-sessions.component';
import { OfflineDebateSessionDetailComponent } from './offline-debate-session-detail/offline-debate-session-detail.component';
import { OfflineDebatesSessionQuestionAnswersComponent } from './offline-debate-session-detail/offline-debates-session-question-answers/offline-debates-session-question-answers.component';

@NgModule({
    declarations: [
        OfflineDebatesListComponent,
        OfflineDebateDetailsComponent,
        OfflineDebateSessionsComponent,
        OfflineDebateSessionDetailComponent,
        OfflineDebatesSessionQuestionAnswersComponent
    ],
    imports: [
        CommonModule,
        OfflineDebatesRoutingModule,
        TextMaskModule,
        CoreModule,
        SharedModule,
        BreadcrumbModule,
        SharedDebatesModule
    ],
    providers: [OfflineDebatesService]
})
export class OfflineDebatesModule { }